<header class="bg-image bg-image-sec">
  <nav class="navbar navbar-expand-lg navbar-light fixed-top bg-white shadow-sm">
    <div class="container">
      <a class="navbar-brand" routerLink="/">
        <img src="../../../../assets/images/enl-solutions-logo-new.png" class="enl-logo"/>
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto"></ul>
        <!-- <form action=""> -->
        <div class="form-inline my-2 my-lg-0 new-link">
            <div class="nav-item dropdown">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown">Port-to-Port</a>
                    <div class="dropdown-menu dropdown-menu-right dropdown-info"
                        aria-labelledby="navbarDropdownMenuLink-4">
                        <a class="dropdown-item" routerLink='/searchresult'><i aria-hidden="true">
                            </i> SEARCH</a>
                        <a class="dropdown-item" routerLink='/raterequestlist'><i aria-hidden="true">
                            </i>Open Cargo</a>
                        <a class="dropdown-item" routerLink='/bookinglist'><i aria-hidden="true">
                            </i>BOOKING REQUESTS</a>
                    </div>
                </li>
            </div>

            <div class="nav-item dropdown">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown">Shipment Tracker</a>
                    <div class="dropdown-menu dropdown-menu-right dropdown-info"
                        aria-labelledby="navbarDropdownMenuLink-4">
                        <a class="dropdown-item" routerLink='/trackingvoyage'><i aria-hidden="true">
                            </i> TRACKING</a>
                    </div>
                </li>
            </div>

              <div class="nav-item dropdown">
                  <li class="nav-item dropdown">
                      <a class="nav-link dropdown-toggle" data-toggle="dropdown">PORT ACTIVITIES</a>
                      <div class="dropdown-menu dropdown-menu-right dropdown-info"
                          aria-labelledby="navbarDropdownMenuLink-4">
                          <a class="dropdown-item" routerLink='/portcalendar'><i aria-hidden="true">
                              </i> PORT CALENDAR</a>
                      </div>
                  </li>
              </div>

              <div class="nav-item dropdown">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown">PORT OPTIMIZER</a>
                    <div class="dropdown-menu dropdown-menu-right dropdown-info"
                        aria-labelledby="navbarDropdownMenuLink-4">
                        <a class="dropdown-item" routerLink='#'><i aria-hidden="true">
                            </i> UNDER DEVELOPMENT</a>
                    </div>
                </li>
            </div>

              <div class="nav-item dropdown">
                  <li class="nav-item dropdown" >
                      <a class="nav-link dropdown-toggle" data-toggle="dropdown">Data Provider</a>
                      <div class="dropdown-menu dropdown-menu-right dropdown-info"
                          aria-labelledby="navbarDropdownMenuLink-4">
                          <a class="dropdown-item" routerLink='#'><i aria-hidden="true">
                              </i> UNDER DEVELOPMENT</a>
                      </div>
                  </li>
              </div>

              <div class="nav-item dropdown">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown">NEWS</a>
                    <div class="dropdown-menu dropdown-menu-right dropdown-info"
                        aria-labelledby="navbarDropdownMenuLink-4">
                        <a class="dropdown-item" routerLink='/news'><i aria-hidden="true">
                            </i> LATEST NEWS</a>
                    </div>
                </li>
            </div>

          <!-- <li class="nav-item">
            <a class="nav-link" routerLink="/freightquotation" routerLinkActive="active">Freight Request</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" routerLink="/services" routerLinkActive="active">Services</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/aboutus" routerLinkActive="active">About Us</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="mailto:contact@enl.solutions" target="_blank">Contact Us</a>
          </li> -->

         <button *ngIf="isSignedIn != true" (click)="openLoginModal()"
            class="btn btn-outline-success btn-sign-in my-2 my-sm-0" type="submit">
            Sign In
          </button>
          <button *ngIf="isSignedIn == true" (click)="signOut()"
            class="btn btn-outline-success btn-sign-in my-2 my-sm-0" type="submit">
            Sign Out
          </button>
        </div>
        <!-- </form> -->
      </div>
    </div>
  </nav>
</header>
